/**
 * @param {string} name 子应用名称，会被拼入 dom id 属性中，应唯一
 * @param {string} entry 可访问到子应用的 url
 * @param {string | string[]} activeRule 不应有冲突，且具备唯一性
 */

export default []
